module.exports = __webpack_public_path__ + "static/media/wellness-yoga.d0afbd9e.svg";